/**
 * Внешний сигнал темы для статических antd-методов (`notification`, `message`,
 * `Modal`). Статика рендерится в собственный React-root вне Router/Redux, тему
 * туда передаём через `ConfigProvider.config({ holderRender })` + этот сигнал.
 *
 * Питается из ClientLayout: пока клиентский модуль смонтирован — `active: true`
 * (+ режим/нативка), при размонтировании — `active: false` → статика возвращает
 * дефолтную тему antd, остальное приложение не затрагивается.
 *
 * Читается через `useSyncExternalStore` (см. notification-theme-provider).
 */
export type TNotifyTheme = {
  active: boolean;
  mode: 'light' | 'dark';
  native: boolean;
};

let snapshot: TNotifyTheme = { active: false, mode: 'light', native: false };
const listeners = new Set<() => void>();

export const setNotifyTheme = (next: TNotifyTheme): void => {
  snapshot = next;
  listeners.forEach((listener) => listener());
};

// Стабильная ссылка: меняется только в setNotifyTheme (важно для useSyncExternalStore).
export const getNotifyTheme = (): TNotifyTheme => snapshot;

export const subscribeNotifyTheme = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
